import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  displayFlexAlignCenter: {
    display: "flex",
    alignItems: "center",
  },
  boxCampaignName: {
    marginLeft: "8px",

    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "4px 8px",
    gap: "8px",

    background: "#F5F5F5",
    borderRadius: "4px",
  },
  accordion: {
    display: "flex",
    maxWidth: 280,
  },
}));
